module.exports = __webpack_public_path__ + "static/media/netresto.4d2f48d7.png";